import { AxiosResponse } from "axios";
import {Company, CompanyQuery, CompanyRequest} from "../models/Company";
import axios from "../utils/axios";
import { fetchAndParse } from "./utilts";
import {Property, PropertyRequest} from "../models/Property";
import {formDataAppendObject} from "../utils/functions";

export function fetchCompany(company: string, token: string) {
  return new Promise<Company>((resolve, reject) => {
    axios
      .get<Company>(
        `${process.env.REACT_APP_API_DOMAIN}/companies/${company}/`,
        {
          headers: { Authorization: "Token " + token },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}



export function updateCompanyFormData(id: string, data: any, token: string) {
  const formData = new FormData()
  Object.entries(data).forEach(([key, value]: [key: any, value: any]) => {
    if (value) {
      if (key === 'logo') {
        const fileName = value.name.substr(0, value.name.indexOf('.'))
        const extension = value.name.substr(value.name.indexOf('.'))
        value = new File(
          [value],
          `${fileName}${extension}`,
          { type: value.type }
        )
      }
      formData.append(key, value as any);
    }
  })
  return new Promise<AxiosResponse<any>>((resolve, reject) => {
    axios
      .patch(`${process.env.REACT_APP_API_DOMAIN}/companies/${id}/`, formData, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}


export function updateCompany(id: string, data: any, token: string) {
  return new Promise<AxiosResponse<any>>((resolve, reject) => {
    axios
      .patch(`${process.env.REACT_APP_API_DOMAIN}/companies/${id}/`, data, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}


export function createCompany(data: any, token: string) {
  return new Promise<AxiosResponse<any>>((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_API_DOMAIN}/companies/`, data, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 201) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}


export function putCompanyInformation(
  companyId: string,
  token: string,
  payload: CompanyRequest
) {
  return new Promise<AxiosResponse<Company>>((resolve, reject) => {
    axios
      .patch(
        `${process.env.REACT_APP_API_DOMAIN}/companies/${companyId}/`,
        payload,
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function retrieveCompany(company: string, token: string) {
  const url = new URL(
    `/companies/${company}/`,
    process.env.REACT_APP_API_DOMAIN
  );
  return fetchAndParse<Company>(url.toString(), {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Token " + token,
    },
  });
}

export function retrieveCompanyOptions(company: string, token: string) {
  const url = new URL(
    `/companies/${company}/`,
    process.env.REACT_APP_API_DOMAIN
  );
  return fetchAndParse<any>(url.toString(), {
    method: "OPTIONS",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Token " + token,
    },
  });
}

export function retrieveCompaniesOptions(token: string) {
  const url = new URL(
    `/companies/`,
    process.env.REACT_APP_API_DOMAIN
  );
  return fetchAndParse<any>(url.toString(), {
    method: "OPTIONS",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Token " + token,
    },
  });
}


export function fetchPagedCompanies(
  token: string,
  page: number,
  search: string,
  removeFirst: boolean = true
) {
  let el_limit = 8
  let offset = (page - 1) * 8;
  if (removeFirst && page === 1) {
    el_limit = 7
  }
  if (page === 2) {
    offset -= 1;
  }

  return new Promise<AxiosResponse<CompanyQuery>>((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_API_DOMAIN}/companies/?limit=${el_limit}&offset=${offset}&search=${search.replace(/&/g, '%26')}&ordering=-created_at`, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getCompaniesInLive(token: string, live: boolean = true, fields: string = 'id,name,is_live_user') {
  let urlParams = '/companies/?limit=999'
  if (live) {
    urlParams = urlParams + '&is_live_user=true'
  }
  if (fields) {
    urlParams = urlParams + `&fields=${fields}`
  }
  const url = new URL(urlParams, process.env.REACT_APP_API_DOMAIN);
  return fetchAndParse<AxiosResponse>(url.toString(), {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Token " + token,
    },
  });
}
